import React from "react";
import UpdatePasswordForm from "./UpdatePasswordForm";
import EstateSelectToolbar from "../../components/EstateSelectToolbar";
import AppBar from "../../components/DefaultAppBar";

const UpdatePasswordContainer = () => (
  <div>
    <AppBar position="static">
      <EstateSelectToolbar noTicketFilter />
    </AppBar>
    <UpdatePasswordForm />
  </div>
);

UpdatePasswordContainer.route = "/update-password";

export default UpdatePasswordContainer;
